import { tenancyScheduleWidgetTableAdapter, State, TenancyScheduleTableInstance } from "../reducers/tenancy-schedule-table";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { QueryBuilderConfigProvider } from '@common/filter/query-builder-config-provider';
import { IRow, ITableColumn } from '@common/models/table';
import { TenancyScheduleFilterFieldProvider } from '@feature/tenancy-schedule/filters/tenancy-schedule-filter-field-provider';
import * as filterSelectors from '@common/filter/selectors/filter.selectors';
import * as filterUtils from '@common/filter/filter-utils';
import * as filterReducers from '@common/filter/reducers/filter.reducers';
import { RuleSet, QueryBuilderConfig } from 'ngx-angular-query-builder';
import * as lodash from 'lodash';
import { StandardFilterStrategy } from "@common/filter/standard-filter-strategy";

export const selectTenancyScheduleState = createFeatureSelector<State>('tenancySchedule');

export type TenancyScheduleFilterFieldProviderFactoryCallback = (rows: Array<IRow>, columns: Array<ITableColumn>) => TenancyScheduleFilterFieldProvider

export function makeTenancyScheduleFilterFieldProviderCallback(): TenancyScheduleFilterFieldProviderFactoryCallback {

    return (rows: Array<IRow>, columns: Array<ITableColumn>) => {
        return new TenancyScheduleFilterFieldProvider(rows, columns);
    }

}

export const {
    selectIds,
    selectEntities,
    selectTotal,
} = tenancyScheduleWidgetTableAdapter.getSelectors(selectTenancyScheduleState);


export const selectEntityByWidgetId = (widgetId: string) => createSelector(selectEntities, (entities) => entities[widgetId.toString()]);


export function getFilteredTenancySchedulesWithDataKey(widgetId: string, filterFieldCallback: TenancyScheduleFilterFieldProviderFactoryCallback) {
    return createSelector(
        [selectEntityByWidgetId(widgetId), getUserFilter(widgetId)],
        (tenancyScheduleTableInstance: TenancyScheduleTableInstance, filter: RuleSet) => {

            const applyFilter = tenancyScheduleTableInstance &&
                tenancyScheduleTableInstance.tenancyScheduleTable &&
                tenancyScheduleTableInstance.tenancyScheduleTable.Rows.length > 0 &&
                filter;

            if (applyFilter) {
                const table = lodash.cloneDeep(tenancyScheduleTableInstance.tenancyScheduleTable);
                const tenancyScheduleFilterFieldProvider = filterFieldCallback(tenancyScheduleTableInstance.tenancyScheduleTable.Rows, tenancyScheduleTableInstance.tenancyScheduleTable.Columns);
                const filterStrategy = new StandardFilterStrategy<IRow>(tenancyScheduleFilterFieldProvider);
                table.Rows = filterStrategy.applyFilter(tenancyScheduleTableInstance.tenancyScheduleTable.Rows, filter);


                let count = 1;
                for (const tenancy of table.Rows) {
                    tenancy.DataKey = String(count++);
                }

                return table;
            }
            return undefined;
        }
    );
}

export function getUserFilter(widgetId: string) {
    return createSelector([filterSelectors.selectByWidgetId(widgetId), selectEntityByWidgetId(widgetId.toString())],
        (filter: filterReducers.WidgetFilterInstance, tenancyScheduleTableInstance: TenancyScheduleTableInstance) => {
            if (filter && tenancyScheduleTableInstance && filter.filter) {
                return filter.filter;
            }
            return filterUtils.getDefaultFilter();
        });
}

export function getQueryBuilderConfig(widgetId: string, filterFieldCallback: TenancyScheduleFilterFieldProviderFactoryCallback) {
    return createSelector(
        [selectEntityByWidgetId(widgetId)],
        (tenancyScheduleTableInstance: TenancyScheduleTableInstance) => {
            if (tenancyScheduleTableInstance &&
                tenancyScheduleTableInstance.tenancyScheduleTable) {

                const tenancyScheduleFilterFieldProvider = filterFieldCallback(tenancyScheduleTableInstance.tenancyScheduleTable.Rows, tenancyScheduleTableInstance.tenancyScheduleTable.Columns);
                const tenancyScheduleFilterFieldProviderQueryConfigBuilder = new QueryBuilderConfigProvider(tenancyScheduleFilterFieldProvider);
                return tenancyScheduleFilterFieldProviderQueryConfigBuilder.getQueryBuilderConfig() as QueryBuilderConfig;
            } else {
                return { fields: {} } as QueryBuilderConfig;
            }
        }
    );
}
